import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=2e412cde&scoped=true&"
import script from "./Timeline.vue?vue&type=script&lang=js&"
export * from "./Timeline.vue?vue&type=script&lang=js&"
import style0 from "./Timeline.vue?vue&type=style&index=0&id=2e412cde&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e412cde",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/components/Button.vue').default})
